import React from "react";
const URLMake = require("../../../../shared/URLMake");
const WonkyButton = require("../../view/WonkyButton");
const StatsIcon = require("../../view/StatsIcon");
const AssetsUtil = require("../AssetsUtil");

/**
 * TODO: notifications kinda weird, we should probably refactor them
 */
export interface NotificationsProps {
	type:
		| "beastbuilder"
		| "giftRewardForRiverCrossing"
		| "redesignTrainer"
		| "trophyUnlocked"
		| "leaderboardsTrainer";
	styles: {
		text: string;
		button: string;
		textLine: string;
		iconContainer: string;
		icon: string;
		textLineWithIcon: string;
	};
	clickHandler: () => void;
}

export const Notifications: React.FC<NotificationsProps> = ({
	type,
	styles,
	clickHandler,
}) => {
	if (type === "beastbuilder") {
		return (
			<React.Fragment>
				<div className={styles.text}>
					Now you can build your own math beast avatar. Visit your Profile page
					to get started!
				</div>
				<WonkyButton
					linkTo={URLMake.forProfile()}
					buttonType="medium-size"
					buttonText={"View Profile"}
					className={styles.button}
					handleClick={clickHandler}
				/>
			</React.Fragment>
		);
	} else if (type === "giftRewardForRiverCrossing") {
		return (
			<React.Fragment>
				<div className={styles.text}>
					Your parent has gifted you 100 beast bucks!
				</div>
			</React.Fragment>
		);
	} else if (type === "redesignTrainer") {
		return (
			<div className={styles.text}>
				<div className={styles.textLine}>
					You may notice that some lessons now have a little monster icon on
					them!
				</div>
				<div className={styles.iconContainer}>
					<StatsIcon type="bonus" style="school" className={styles.icon} />
				</div>
				<div className={styles.textLine}>
					These enrichment lessons go beyond what is typically taught in most
					classrooms. These lessons are great for when you need a challenge or
					if you want to learn a new topic.
				</div>
				<div className={styles.textLine}>
					Do your best and don't worry if some of them stump you—they can be
					tough!
				</div>
			</div>
		);
	} else if (type === "trophyUnlocked") {
		return (
			<div className={styles.text}>
				<div className={styles.textLine}>CONGRATULATIONS!</div>
				<div className={styles.textLine}>You've unlocked a trophy problem!</div>
				<div className={styles.textLine}>
					{
						"In some lessons, you uncover a bonus trophy problem by earning at least 1 star."
					}
				</div>
				<div className={styles.textLine}>
					Click the trophy icon on a lesson to try it!
				</div>
			</div>
		);
	} else if (type === "leaderboardsTrainer") {
		return (
			<div className={styles.text}>
				<div className={styles.textLine}>
					Beast Academy now has leaderboards!
				</div>
				<div className={styles.textLineWithIcon}>
					Click the{" "}
					<img
						src={AssetsUtil.getButton("leaderboards")}
						className={styles.icon}
					/>
					in the top bar to check them out.
				</div>
			</div>
		);
	}
	return null;
};
